import React from "react";
import Icon from "components/Varios/Icons.js";
import Select from 'react-select';

import TooltipItem from "components/Varios/Tooltip.js";

export default class SelectItem extends React.Component {

    customStyles = {
        container: (provided, state) => ({
            ...provided,
            height: this.getPropIsMulti() ? "27px" : "fit-content",
            position: "relative",
            flex: "1 1 auto",
            width: "1%",
            minWidth: "0",
            marginBottom: "0",
        }),

        indicatorContainer: (provided) => ({
            ...provided,
            width: "0%",
            display: "none"
        }),
        input: (provided) => ({
            ...provided,
            "fontWeight": "bold"
        }),
        singleValue: (provided, state) => {

            const weigth = state.isDisabled ? "normal" : "bold"
            return {
                ...provided,
                fontWeight: weigth,
                // color:"black"
            };
        },
        control: (provided, state) => {
            const backgroundColor = state.isDisabled ? "#E3E3E3" : "#fff";
            return {
                ...provided,
                borderRadius: "0px",
                border: "1px solid #E3E3E3",
                backgroundColor: "transparent",
                color: "#2c2c2c",
                lineHeight: "normal",
                minHeight: "27px",
                height: "27px",
                fontSize: "0.8571em",
                boxShadow: "none",
                width: "auto",
                fontFamily: "Montserrat",
                backgroundColor
            }
        },
        menu: (provided, state) => {
            const width = state.width ? state.width : "auto";
            return {
                ...provided,
                fontSize: "0.95em",
                minWidth: "300px",
                zIndex: "100",
                width
            }

        },
    }

    state = {
        selectedValue: this.props.value,
    };

    handleChange = (selectedValue) => {
        this.setState(
            { selectedValue },
            (() => {
                if (!this.getPropIsMulti(this.props.isMulti)) {
                    this.props.onChange(selectedValue.value, this.props.name, this.props.tipo, selectedValue.label)
                }
                else {
                    this.props.onChange(selectedValue)
                }
            })
            //(() => { this.props.onChange(selectedValue ? selectedValue.value : null, this.props.name, this.props.tipo, selectedValue ? selectedValue.label : "") })
        );
    };

    handleValueSelect = (value, isMulti) => {


        if (value !== null && value !== undefined && !isMulti && this.props.options.length > 0) {
            if (this.props.options.find(obj => obj.value.toString() === value.toString())) {
                return this.props.options.find(obj => obj.value.toString() === value.toString())
            }
            else {
                return null
            }
        }
        else if (isMulti && value) {
            return this.props.value
        }
        else { return null }

    }

    getPropIsMulti = () => {
        if (this.props.isMulti !== undefined) {
            return this.props.isMulti
        }
        else { return false }
    }

    render() {
        const componenteRenderizar = (
            <React.Fragment>
                <Select
                    options={this.props.options}
                    value={this.handleValueSelect(this.props.value, this.getPropIsMulti())}
                    onChange={this.handleChange}
                    styles={this.customStyles}
                    placeholder={this.props.placeholder}
                    name={this.props.name}
                    id={this.props.id}
                    isDisabled={(this.props.disabled)}
                    isRequired={true}
                    isMulti={this.getPropIsMulti()}
                    isSearchable={this.props.isSearchable !== undefined ? this.props.isSearchable : true}
                    required={this.props.required !== undefined ? this.props.required : false}
                //isClearable={true}
                />
                <div className="input-group-append mr-1" style={{ backgroundColor: "#FFC200" }}>
                    {this.props.icon.startsWith("fa-") ? (<i className={"fas " + this.props.icon} aria-hidden="true"></i>) : (<Icon kind={this.props.icon} fill='#FFFFFF' width={27} height={27} />)}

                </div>
                {/* {
                    (this.props.disabledHover !== undefined && this.props.disabledHover === false && this.props.placeholder) || (this.props.disabledHover === undefined) &&
                    <TooltipItem content={this.props.placeholder} id={this.props.id} />

                } */}
            </React.Fragment>
        )

        if (this.props.rowRender !== undefined && this.props.rowRender) {
            return (componenteRenderizar)
        }
        return (
            <div className="input-group">
                {componenteRenderizar}
            </div>
        )

    }
}